<onyx-modal
  variant="center"
  [size]="480"
  [heading]="HEADING"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <div class="container">
    @if (isFinish) {
      <onyx-message intent="neutral">
        <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

        {{ `${I18N}.closeWillRejectOrdersProposals` | translate }}
      </onyx-message>

      <onyx-divider></onyx-divider>
    }

    <div class="details">
      <div class="wrapper gray">
        @let delegations = data.delegations;
        @if (delegations.length === 1) {
          <p>{{ 'labels.id' | translate }}</p>

          <p>
            {{
              (delegations[0].secondaryDriver
                ? 'labels.drivers'
                : 'labels.driver'
              ) | translate
            }}
          </p>
        }

        <p>{{ 'labels.vehicle' | translate }}</p>
      </div>

      <div class="wrapper f-body-m f-medium">
        @if (delegations.length === 1) {
          <p>{{ delegations[0].identifier }}</p>
          <p>{{ drivers[0] | join: { maxLength: 2 } }}</p>
        }

        @if (data.telematicsItem) {
          <p>{{ data.telematicsItem.generalInformation | fleetIdentifier }}</p>
        } @else if ('vehicle' in data.delegations[0]) {
          <p>{{ data.delegations[0].vehicle | fleetIdentifier }}</p>
        }
      </div>
    </div>

    @if (!isSettle) {
      <onyx-divider></onyx-divider>

      <form [formArray]="form" [onyxAutoFocus]="true">
        @for (control of form.controls; track control) {
          <div [formGroup]="control" class="item">
            @let controls = control.controls;

            @if (delegations.length > 1) {
              @if (!$first) {
                <onyx-divider></onyx-divider>
              }

              <div class="toggle">
                <onyx-toggle
                  [formControl]="controls.selected"
                  [size]="32"
                ></onyx-toggle>

                {{ drivers[$index] | join: { maxLength: 2 } }}
                ({{ delegations[$index].identifier }})
              </div>
            }

            @if (controls.selected.value) {
              <div class="group">
                <onyx-form-group [controls]="controls.date">
                  <onyx-datepicker
                    [formControl]="controls.date"
                    label="labels.date"
                    [yearsRange]="{ past: 1, future: 1 }"
                    [showErrors]="false"
                  ></onyx-datepicker>

                  <onyx-suggestions
                    [control]="controls.date"
                    [suggestions]="DATE_SUGGESTIONS"
                  ></onyx-suggestions>
                </onyx-form-group>

                <onyx-form-group [controls]="controls.time">
                  <onyx-timepicker
                    [formControl]="controls.time"
                    label="labels.hour"
                    [showErrors]="false"
                  ></onyx-timepicker>

                  <onyx-suggestions
                    [control]="controls.time"
                    [suggestions]="TIME_SUGGESTIONS"
                    (selectedSuggestionChange)="controls.date.setValue(TODAY)"
                  ></onyx-suggestions>
                </onyx-form-group>
              </div>

              <onyx-address-input
                [formControl]="controls.address"
                label="labels.address"
                [showApartment]="true"
                apartmentWidth="100px"
              ></onyx-address-input>
            }
          </div>
        }
      </form>
    }
  </div>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    @let disabled =
      delegations.some((delegation) => !!delegation.relatedFleetSwap);
    <onyx-button
      [spinner]="loading()"
      [disabled]="disabled"
      [onyxTooltip]="disabled ? 'labels.disabledUntilSwapCompleted' : ''"
      (click)="!loading() && !disabled ? submit() : null"
    >
      {{ SUBMIT_LABEL | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
